import { defineStore } from "pinia";
import { ref } from "vue";
import type { SystemTemplatesResponse, SystemColumn } from "@/features/reporting/interfaces/TemplateInterfaces";

export const useSystemTemplateBuilderStore = defineStore("system-template-builder", () => {
  const systemTemplates = ref<SystemTemplatesResponse[]>([]);
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  /**
   * Add template only if capability not already present
   */
  const addSystemTemplate = (temp: SystemTemplatesResponse) => {
    const existing = systemTemplates.value.find((t) => t.capability === temp.capability);

    if (!existing) {
      systemTemplates.value.push(temp);
    } else {
      // Replace existing template
      Object.assign(existing, temp);
    }
  };

  /**
   * Get template by capability
   */
  const getSystemTemplateByCapability = (cap: string) => {
    return systemTemplates.value.find((t) => t.capability === cap) || null;
  };

  /**
   * Get column values by capability + column name
   */
  const getColumnValuesByCapability = (
    capability: string,
    reportType: string,
    columnId: string
  ): SystemColumn | null => {
    const template = getSystemTemplateByCapability(capability);

    if (!template) return null;

    const reportTypeObj = template.reportTypes.find((rt) => rt.reportType === reportType);

    if (!reportTypeObj) return null;

    for (const group of reportTypeObj.groups) {
      const column = group.columns.find((c) => c.id === columnId);

      if (column) return column;
    }

    return null;
  };

  return {
    systemTemplates,
    isLoading,
    error,

    addSystemTemplate,
    getSystemTemplateByCapability,
    getColumnValuesByCapability
  };
});
